import { Icon as Icons } from '@material-ui/core'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const LabelCard = styled.div`
  padding-bottom: 20px;
`

export const Value = styled.span<{ backgroundColor?: string }>`
  color: ${({ backgroundColor }) =>
    backgroundColor ? colors.white : colors.grayDark};
  font-size: 14px;
  font-weight: 700;
  border-radius: 2px;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ?? 'transparent'};
`
export const Icon = styled(Icons)`
  color: ${colors.blue};
  display: flex;
  align-items: center;
`
export const Title = styled.span`
  color: ${colors.blue};
  font-size: 14px;
`

export const Subtitle = styled.span`
  color: ${colors.grayDark};
  font-size: 14px;
  font-weight: 700;
`
